import { createScreenText } from 'helpers/screenText';
const st = createScreenText('print_house_management');

// src/pages/PrintHouseManagement/types.ts
// README.md mục 7 — types cho danh mục Nhà in (CRUD), copy khung TicketTypeManagement/types.ts.

export interface PrintHouse {
  id: number;
  code: string;
  name: string;
  address: string;
  contactName?: string | null;
  contactPhone?: string | null;
  note?: string | null;
  isActive: boolean;
  createdAt: string;
  lastModifiedAt?: string | null;
}

export interface CreatePrintHouseDto {
  code: string;
  name: string;
  address: string;
  contactName?: string;
  contactPhone?: string;
  note?: string;
}

export interface UpdatePrintHouseDto {
  id: number;
  name: string;
  address: string;
  contactName?: string;
  contactPhone?: string;
  note?: string;
  isActive: boolean;
}

export interface PrintHouseFilters {
  searchTerm: string;
  isActive: 'All' | 'true' | 'false';
}

export interface PrintHousePagination {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface PrintHouseModalState {
  create: boolean;
  edit: boolean;
}

export const ACTIVE_STATUS_OPTIONS: { value: PrintHouseFilters['isActive']; label: string }[] = [
  { value: 'All', label: st('tat_ca_trang_thai_label') },
  { value: 'true', label: st('dang_hoat_dong_text') },
  { value: 'false', label: st('ngung_hoat_dong_text') },
];
